// extracted by mini-css-extract-plugin
export default {"root":"CircularProgress_root__6QW-U","loadingAnimation":"CircularProgress_loadingAnimation__nLYWA"};